// src/pages/nascar/TrucksData.jsx
import NascarData from "./NascarData";
export default function TrucksData() { return <NascarData series="trucks" />; }